import * as React from "react";

function CloseIcon(props) {
  return (
    <svg viewBox="0 0 96 96" {...props}>
      <path
        fill="#333"
        d="M70.2 30.3l-4.5-4.5L48 43.5 30.3 25.8l-4.5 4.5L43.5 48 25.8 65.7l4.5 4.5L48 52.5l17.7 17.7 4.5-4.5L52.5 48z"
      />
    </svg>
  );
}

export default CloseIcon;
